import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Roles } from "@/interfaces/employee_type";
import { useAuth } from "../../App";
import { getProject } from "../../api/projects";
import { getTaskByID } from "../../api/tasks";
import { TaskProps } from "../../interfaces/tasks_types";
import { TaskForm } from "./Form/TaskForm";

/**
 *  ### Route for ('/tasks/create_task')
 *
 */
export function CreateTask() {
	return <TaskForm method="POST" />;
}

/**
 *  ### Route for ('/tasks/update_task/:id')
 *
 *
 */
export function EditTask() {
	const { id } = useParams<string>();
	const [task_data, setTaskData] = useState<TaskProps>();

	useEffect(() => {
		if (!id) return;
		const fetchData = async () => {
			try {
				const task = await getTaskByID(id);

				if (!task) {
					throw new Error("Error fetching task data");
				}

				setTaskData({ ...task, task_id: id });
			} catch (error) {
				console.error(error);
			}
		};

		fetchData();
	}, [id]);
	return <>{task_data && <TaskForm method="PUT" task_data={task_data} />}</>;
}

/**
 *  ### Route for ('/tasks/create_task_from_project')
 *
 *  This is a seperate route for creating a task from a project card
 *
 * I might want to just use the TaskForm component for this...
 */
export function CreateTaskFromProject() {
	const { id } = useParams<string>();
	const { user } = useAuth();

	const [task_data, setTaskData] = useState<TaskProps>();

	useEffect(() => {
		if (!id) return;

		const fetchData = async () => {
			try {
				const project = await getProject(id);

				if (!project) {
					throw new Error("Error fetching task data");
				}

				// I need it in this format because the TaskForm find the project in this format...
				// Yet another hacky solution...

				setTaskData({
					task_id: "",
					project: project.data.project_name,
					title: "",
					description: "",
					assigned_by: user?.name ?? "", // THIS DOESN'T DEFAULT TO USERNAME (The task form uses the obj version)
					assigned_by_obj: {
						name: user?.name ?? "",
						email: user?.email ?? "",
						username: user?.username ?? "",
						password: user?.password ?? "",
						role: user?.role as Roles,
					},
					assigned_to: "",
					project_id: project.data.project_id ?? "",
					due_date: new Date().toLocaleDateString("en-CA"),
					status: "Active",
					category: "Other",
					completion_percentage: 0,
					priority: "Normal",
				});
			} catch (error) {
				console.error(error);
			}
		};

		fetchData();
	}, [id, user]);

	return <>{task_data && <TaskForm method="POST" task_data={task_data} />}</>;
}
